// @flow
import React, { Fragment } from "react";

import type { $SiteOfficeBroker } from "flow/types";

type $Props = {
  broker: $SiteOfficeBroker,
};

const BrokerInfo = ({ broker }: $Props) => (
  <Fragment>
    {broker.fullName && (
      <div className={"ref__footer-broker-name"}>Broker: {broker.fullName}</div>
    )}
    {broker.title && <div>{broker.title}</div>}
    {broker.licenseType && (
      <div className={"ref__footer-broker-license-type"}>
        {broker.licenseType}
      </div>
    )}
    {broker.officePhone && (
      <div>
        <a
          href={`tel:${broker.officePhone}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Office: {broker.officePhoneFormatted}
        </a>
      </div>
    )}
    {broker.cellPhone && (
      <div>
        <a
          href={`tel:${broker.cellPhone}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Cell: {broker.cellPhoneFormatted}
        </a>
      </div>
    )}
  </Fragment>
);

export default BrokerInfo;
